import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const CreateObservationFromShortVariantDocument = gql`
  mutation CreateObservationFromShortVariant(
    $user: String!
    $effectiveDateTime: String!
    $datasetId: String!
    $subjectRef: String!
    $variantId: String!
    $sequenceId: String!
    $testId: String!
    $ncChange: String!
    $aaChange: String!
    $gene: String!
    $refSeqId: String!
    $loincSequenceClass: String!
    $sequenceType: String!
    $position: QuantityIn!
    $refAllele: String!
    $altAllele: String!
    $setType: String!
    $alleleFrequency: Float!
  ) {
    createObservation(
      observation: {
        resourceType: Observation
        effectiveDateTime: $effectiveDateTime
        subject: { reference: $subjectRef }
        code: {
          coding: [
            {
              code: "69548-6"
              system: "http://loinc.org"
              display: "Genetic variant assessment"
            }
          ]
        }
        meta: {
          tag: [
            { code: $datasetId, system: "http://lifeomic.com/fhir/dataset" }
            {
              code: "LifeOmic Variant Selection"
              system: "http://lifeomic.com/fhir/source"
            }
          ]
        }
        performer: { identifier: { id: $user } }
        status: final
        extension: [
          {
            url: "http://hl7.org/fhir/StructureDefinition/observation-geneticsSequence"
            valueString: $sequenceId
          }
          {
            url: "http://hl7.org/fhir/StructureDefinition/variant-id"
            valueString: $variantId
          }
          {
            url: "http://hl7.org/fhir/StructureDefinition/test-id"
            valueString: $testId
          }
          {
            url: "http://hl7.org/fhir/StructureDefinition/variant-set-type"
            valueString: $setType
          }
        ]
        valueCodeableConcept: {
          coding: [
            { system: "http://loinc.org", code: "LA9633-4", display: "present" }
          ]
        }
        component: [
          {
            code: {
              coding: [
                {
                  system: "http://loinc.org"
                  code: "48004-6"
                  display: "DNA change (c.HGVS)"
                }
              ]
            }
            valueCodeableConcept: {
              coding: [
                {
                  system: "http://varnomen.hgvs.org"
                  code: $ncChange
                  display: $ncChange
                }
              ]
            }
          }
          {
            code: {
              coding: [
                {
                  system: "http://loinc.org"
                  code: "53721-7"
                  display: "Amino acid marker assessed [Identifier]"
                }
              ]
            }
            valueString: $aaChange
          }
          {
            code: {
              coding: [
                {
                  system: "http://loinc.org"
                  code: "48018-6"
                  display: "Gene studied ID"
                }
              ]
            }
            valueCodeableConcept: {
              coding: [
                {
                  system: "http://www.genenames.org/gene"
                  code: $gene
                  display: $gene
                }
              ]
            }
          }
          {
            code: {
              coding: [
                {
                  system: "http://loinc.org"
                  code: "48013-7"
                  display: "Genomic reference sequence ID"
                }
              ]
            }
            valueCodeableConcept: {
              coding: [
                {
                  system: "http://www.ncbi.nlm.nih.gov/nuccore"
                  code: $refSeqId
                  display: $refSeqId
                }
              ]
            }
          }
          {
            code: {
              coding: [
                {
                  system: "http://loinc.org"
                  code: "48002-0"
                  display: "Genomic Source Class"
                }
              ]
            }
            valueCodeableConcept: {
              coding: [
                {
                  system: "http://loinc.org"
                  code: $loincSequenceClass
                  display: $sequenceType
                }
              ]
            }
          }
          {
            code: {
              coding: [
                {
                  system: "http://loinc.org"
                  code: "69547-8"
                  display: "Genomic Ref allele [ID]"
                }
              ]
            }
            valueString: $refAllele
          }
          {
            code: {
              coding: [
                {
                  system: "http://loinc.org"
                  code: "69551-0"
                  display: "Genomic Alt allele [ID]"
                }
              ]
            }
            valueString: $altAllele
          }
          {
            code: {
              coding: [
                {
                  system: "http://loinc.org"
                  code: "92822-6"
                  display: "Genomic coord system"
                }
              ]
            }
            valueCodeableConcept: {
              coding: [
                { system: "LA30102-0", code: "1-based character counting" }
              ]
            }
          }
          {
            code: {
              coding: [
                {
                  system: "http://loinc.org"
                  code: "81254-5"
                  display: "Variant exact start-end"
                }
              ]
            }
            valueRange: { low: $position }
          }
          {
            code: {
              coding: [
                {
                  code: "81258-6"
                  system: "http://loinc.org"
                  display: "Sample variant allelic frequency [NFr]"
                }
              ]
            }
            valueQuantity: {
              value: $alleleFrequency
              system: "http://unitsofmeasure.org"
              code: "%"
              unit: "percent"
            }
          }
        ]
      }
    ) {
      id
      __typename
      effectiveDateTime
      subject {
        reference
      }
      meta {
        tag {
          code
          system
        }
      }
      component {
        code {
          coding {
            system
            code
            display
          }
        }
        valueString
        valueCodeableConcept {
          coding {
            system
            code
            display
          }
        }
      }
      extension {
        url
        valueString
      }
    }
  }
`;
export type CreateObservationFromShortVariantMutationFn =
  ApolloReactCommon.MutationFunction<
    CreateObservationFromShortVariantMutationResponse,
    CreateObservationFromShortVariantMutationVariables
  >;

/**
 * __useCreateObservationFromShortVariantMutation__
 *
 * To run a mutation, you first call `useCreateObservationFromShortVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObservationFromShortVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObservationFromShortVariantMutation, { data, loading, error }] = useCreateObservationFromShortVariantMutation({
 *   variables: {
 *      user: // value for 'user'
 *      effectiveDateTime: // value for 'effectiveDateTime'
 *      datasetId: // value for 'datasetId'
 *      subjectRef: // value for 'subjectRef'
 *      variantId: // value for 'variantId'
 *      sequenceId: // value for 'sequenceId'
 *      testId: // value for 'testId'
 *      ncChange: // value for 'ncChange'
 *      aaChange: // value for 'aaChange'
 *      gene: // value for 'gene'
 *      refSeqId: // value for 'refSeqId'
 *      loincSequenceClass: // value for 'loincSequenceClass'
 *      sequenceType: // value for 'sequenceType'
 *      position: // value for 'position'
 *      refAllele: // value for 'refAllele'
 *      altAllele: // value for 'altAllele'
 *      setType: // value for 'setType'
 *      alleleFrequency: // value for 'alleleFrequency'
 *   },
 * });
 */
export function useCreateObservationFromShortVariantMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateObservationFromShortVariantMutationResponse,
    CreateObservationFromShortVariantMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateObservationFromShortVariantMutationResponse,
    CreateObservationFromShortVariantMutationVariables
  >(CreateObservationFromShortVariantDocument, baseOptions);
}
export type CreateObservationFromShortVariantMutationHookResult = ReturnType<
  typeof useCreateObservationFromShortVariantMutation
>;
export type CreateObservationFromShortVariantMutationResult =
  ApolloReactCommon.MutationResult<CreateObservationFromShortVariantMutationResponse>;
export type CreateObservationFromShortVariantMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateObservationFromShortVariantMutationResponse,
    CreateObservationFromShortVariantMutationVariables
  >;
export const CreateObservationFromStructuralVariantDocument = gql`
  mutation CreateObservationFromStructuralVariant(
    $user: String!
    $datasetId: String!
    $subjectRef: String!
    $variantId: String!
    $testId: String!
    $effectCoding: [CodingIn]!
    $geneIdCoding: [CodingIn]!
    $position1: RangeIn!
    $position2: RangeIn!
    $loincSequenceClass: String!
    $sequenceType: String!
    $sequenceId: String!
    $effectiveDateTime: String!
  ) {
    createObservation(
      observation: {
        resourceType: Observation
        effectiveDateTime: $effectiveDateTime
        subject: { reference: $subjectRef }
        code: {
          coding: [
            {
              code: "69548-6"
              system: "http://loinc.org"
              display: "Genetic variant assessment"
            }
          ]
        }
        meta: {
          tag: [
            { code: $datasetId, system: "http://lifeomic.com/fhir/dataset" }
            {
              code: "LifeOmic Variant Selection"
              system: "http://lifeomic.com/fhir/source"
            }
          ]
        }
        performer: { identifier: { id: $user } }
        status: final
        extension: [
          {
            url: "http://hl7.org/fhir/StructureDefinition/observation-geneticsSequence"
            valueString: $sequenceId
          }
          {
            url: "http://hl7.org/fhir/StructureDefinition/variant-id"
            valueString: $variantId
          }
          {
            url: "http://hl7.org/fhir/StructureDefinition/test-id"
            valueString: $testId
          }
          {
            url: "http://hl7.org/fhir/StructureDefinition/variant-set-type"
            valueString: "structuralVariant"
          }
        ]
        valueCodeableConcept: {
          coding: [
            { system: "http://loinc.org", code: "LA9633-4", display: "present" }
          ]
        }
        component: [
          {
            code: { coding: [{ code: "48019-4", system: "http://loinc.org" }] }
            valueCodeableConcept: { coding: $effectCoding }
          }
          {
            code: { coding: [{ code: "48018-6", system: "http://loinc.org" }] }
            valueCodeableConcept: { coding: $geneIdCoding }
          }
          {
            code: { coding: [{ code: "48002-0", system: "http://loinc.org" }] }
            valueCodeableConcept: {
              coding: [
                {
                  system: "http://loinc.org"
                  code: $loincSequenceClass
                  display: $sequenceType
                }
              ]
            }
          }
          {
            code: { coding: [{ code: "81301-4", system: "http://loinc.org" }] }
            valueRange: $position1
          }
          {
            code: { coding: [{ code: "81302-2", system: "http://loinc.org" }] }
            valueRange: $position2
          }
        ]
      }
    ) {
      id
      status
      effectiveDateTime
      subject {
        reference
      }
      meta {
        tag {
          code
          system
        }
      }
      component {
        code {
          coding {
            system
            code
            display
          }
        }
        valueString
        valueRange {
          low {
            value
          }
          high {
            value
          }
        }
        valueCodeableConcept {
          coding {
            system
            code
            display
          }
        }
      }
      extension {
        url
        valueString
      }
    }
  }
`;
export type CreateObservationFromStructuralVariantMutationFn =
  ApolloReactCommon.MutationFunction<
    CreateObservationFromStructuralVariantMutationResponse,
    CreateObservationFromStructuralVariantMutationVariables
  >;

/**
 * __useCreateObservationFromStructuralVariantMutation__
 *
 * To run a mutation, you first call `useCreateObservationFromStructuralVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObservationFromStructuralVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObservationFromStructuralVariantMutation, { data, loading, error }] = useCreateObservationFromStructuralVariantMutation({
 *   variables: {
 *      user: // value for 'user'
 *      datasetId: // value for 'datasetId'
 *      subjectRef: // value for 'subjectRef'
 *      variantId: // value for 'variantId'
 *      testId: // value for 'testId'
 *      effectCoding: // value for 'effectCoding'
 *      geneIdCoding: // value for 'geneIdCoding'
 *      position1: // value for 'position1'
 *      position2: // value for 'position2'
 *      loincSequenceClass: // value for 'loincSequenceClass'
 *      sequenceType: // value for 'sequenceType'
 *      sequenceId: // value for 'sequenceId'
 *      effectiveDateTime: // value for 'effectiveDateTime'
 *   },
 * });
 */
export function useCreateObservationFromStructuralVariantMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateObservationFromStructuralVariantMutationResponse,
    CreateObservationFromStructuralVariantMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateObservationFromStructuralVariantMutationResponse,
    CreateObservationFromStructuralVariantMutationVariables
  >(CreateObservationFromStructuralVariantDocument, baseOptions);
}
export type CreateObservationFromStructuralVariantMutationHookResult =
  ReturnType<typeof useCreateObservationFromStructuralVariantMutation>;
export type CreateObservationFromStructuralVariantMutationResult =
  ApolloReactCommon.MutationResult<CreateObservationFromStructuralVariantMutationResponse>;
export type CreateObservationFromStructuralVariantMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateObservationFromStructuralVariantMutationResponse,
    CreateObservationFromStructuralVariantMutationVariables
  >;
export const CreateObservationFromCopyNumberVariantDocument = gql`
  mutation CreateObservationFromCopyNumberVariant(
    $user: String!
    $datasetId: String!
    $subjectRef: String!
    $variantId: String!
    $geneId: String!
    $position: RangeIn!
    $copyNumberValue: Float!
    $typeCoding: [CodingIn]!
    $loincSequenceClass: String!
    $sequenceType: String!
    $sequenceId: String!
    $testId: String!
    $effectiveDateTime: String!
  ) {
    createObservation(
      observation: {
        resourceType: Observation
        effectiveDateTime: $effectiveDateTime
        subject: { reference: $subjectRef }
        code: {
          coding: [
            {
              code: "69548-6"
              system: "http://loinc.org"
              display: "Genetic variant assessment"
            }
          ]
        }
        meta: {
          tag: [
            { code: $datasetId, system: "http://lifeomic.com/fhir/dataset" }
            {
              code: "LifeOmic Variant Selection"
              system: "http://lifeomic.com/fhir/source"
            }
          ]
        }
        performer: { identifier: { id: $user } }
        status: final
        extension: [
          {
            url: "http://hl7.org/fhir/StructureDefinition/observation-geneticsSequence"
            valueString: $sequenceId
          }
          {
            url: "http://hl7.org/fhir/StructureDefinition/test-id"
            valueString: $testId
          }
          {
            url: "http://hl7.org/fhir/StructureDefinition/variant-id"
            valueString: $variantId
          }
          {
            url: "http://hl7.org/fhir/StructureDefinition/variant-set-type"
            valueString: "copyNumberVariant"
          }
        ]
        valueCodeableConcept: {
          coding: [
            { system: "http://loinc.org", code: "LA9633-4", display: "present" }
          ]
        }
        component: [
          {
            code: {
              coding: [
                {
                  code: "48019-4"
                  system: "http://loinc.org"
                  display: "DNA Change type"
                }
              ]
            }
            valueCodeableConcept: {
              coding: [
                {
                  code: "SO:0001019"
                  system: "http://sequenceontology.org"
                  display: "copy_number_variation"
                }
              ]
            }
          }
          {
            code: { coding: [{ code: "48018-6", system: "http://loinc.org" }] }
            valueCodeableConcept: {
              coding: [
                { code: $geneId, system: "http://www.genenames.org/geneId" }
              ]
            }
          }
          {
            code: {
              coding: [
                {
                  code: "48002-0"
                  system: "http://loinc.org"
                  display: "Genomic Source Class"
                }
              ]
            }
            valueCodeableConcept: {
              coding: [
                {
                  system: "http://loinc.org"
                  code: $loincSequenceClass
                  display: $sequenceType
                }
              ]
            }
          }
          {
            code: { coding: [{ code: "81301-4", system: "http://loinc.org" }] }
            valueRange: $position
          }
          {
            code: { coding: [{ code: "82155-3", system: "http://loinc.org" }] }
            valueQuantity: {
              value: $copyNumberValue
              system: "http://unitsofmeasure.org"
              code: "1"
            }
          }
          {
            code: {
              coding: [
                {
                  code: "Copy Number Type"
                  system: "http://lifeomic.com/fhir/copyNumberType"
                }
              ]
            }
            valueCodeableConcept: { coding: $typeCoding }
          }
        ]
      }
    ) {
      id
      status
      effectiveDateTime
      subject {
        reference
      }
      meta {
        tag {
          code
          system
        }
      }
      component {
        code {
          coding {
            system
            code
            display
          }
        }
        valueString
        valueRange {
          low {
            value
          }
          high {
            value
          }
        }
        valueCodeableConcept {
          coding {
            system
            code
            display
          }
        }
      }
      extension {
        url
        valueString
      }
    }
  }
`;
export type CreateObservationFromCopyNumberVariantMutationFn =
  ApolloReactCommon.MutationFunction<
    CreateObservationFromCopyNumberVariantMutationResponse,
    CreateObservationFromCopyNumberVariantMutationVariables
  >;

/**
 * __useCreateObservationFromCopyNumberVariantMutation__
 *
 * To run a mutation, you first call `useCreateObservationFromCopyNumberVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObservationFromCopyNumberVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObservationFromCopyNumberVariantMutation, { data, loading, error }] = useCreateObservationFromCopyNumberVariantMutation({
 *   variables: {
 *      user: // value for 'user'
 *      datasetId: // value for 'datasetId'
 *      subjectRef: // value for 'subjectRef'
 *      variantId: // value for 'variantId'
 *      geneId: // value for 'geneId'
 *      position: // value for 'position'
 *      copyNumberValue: // value for 'copyNumberValue'
 *      typeCoding: // value for 'typeCoding'
 *      loincSequenceClass: // value for 'loincSequenceClass'
 *      sequenceType: // value for 'sequenceType'
 *      sequenceId: // value for 'sequenceId'
 *      testId: // value for 'testId'
 *      effectiveDateTime: // value for 'effectiveDateTime'
 *   },
 * });
 */
export function useCreateObservationFromCopyNumberVariantMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateObservationFromCopyNumberVariantMutationResponse,
    CreateObservationFromCopyNumberVariantMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateObservationFromCopyNumberVariantMutationResponse,
    CreateObservationFromCopyNumberVariantMutationVariables
  >(CreateObservationFromCopyNumberVariantDocument, baseOptions);
}
export type CreateObservationFromCopyNumberVariantMutationHookResult =
  ReturnType<typeof useCreateObservationFromCopyNumberVariantMutation>;
export type CreateObservationFromCopyNumberVariantMutationResult =
  ApolloReactCommon.MutationResult<CreateObservationFromCopyNumberVariantMutationResponse>;
export type CreateObservationFromCopyNumberVariantMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateObservationFromCopyNumberVariantMutationResponse,
    CreateObservationFromCopyNumberVariantMutationVariables
  >;
export const CreateObservationFromExpressionVariantDocument = gql`
  mutation CreateObservationFromExpressionVariant(
    $user: String!
    $datasetId: String!
    $subjectRef: String!
    $variantId: String!
    $geneId: String!
    $expressionValue: Float!
    $expressionUnitSystem: String!
    $expressionUnitCode: String!
    $loincSequenceClass: String!
    $sequenceType: String!
    $sequenceId: String!
    $testId: String!
    $effectiveDateTime: String!
  ) {
    createObservation(
      observation: {
        resourceType: Observation
        effectiveDateTime: $effectiveDateTime
        subject: { reference: $subjectRef }
        code: {
          coding: [
            {
              code: "69548-6"
              system: "http://loinc.org"
              display: "Genetic variant assessment"
            }
          ]
        }
        meta: {
          tag: [
            { code: $datasetId, system: "http://lifeomic.com/fhir/dataset" }
            {
              code: "LifeOmic Variant Selection"
              system: "http://lifeomic.com/fhir/source"
            }
          ]
        }
        performer: { identifier: { id: $user } }
        status: final
        extension: [
          {
            url: "http://hl7.org/fhir/StructureDefinition/observation-geneticsSequence"
            valueString: $sequenceId
          }
          {
            url: "http://hl7.org/fhir/StructureDefinition/variant-id"
            valueString: $variantId
          }
          {
            url: "http://hl7.org/fhir/StructureDefinition/test-id"
            valueString: $testId
          }
          {
            url: "http://hl7.org/fhir/StructureDefinition/variant-set-type"
            valueString: "expressionVariant"
          }
        ]
        valueCodeableConcept: {
          coding: [
            { system: "http://loinc.org", code: "LA9633-4", display: "present" }
          ]
        }
        component: [
          {
            code: { coding: [{ code: "48018-6", system: "http://loinc.org" }] }
            valueCodeableConcept: {
              coding: [
                { code: $geneId, system: "http://www.genenames.org/geneId" }
              ]
            }
          }
          {
            code: {
              coding: [
                {
                  code: "48002-0"
                  system: "http://loinc.org"
                  display: "Genomic Source Class"
                }
              ]
            }
            valueCodeableConcept: {
              coding: [
                {
                  system: "http://loinc.org"
                  code: $loincSequenceClass
                  display: $sequenceType
                }
              ]
            }
          }
          {
            code: {
              coding: [
                {
                  code: "Expression Value"
                  system: "http://lifeomic.com/fhir/expressionValue"
                }
              ]
            }
            valueQuantity: {
              value: $expressionValue
              system: $expressionUnitSystem
              code: $expressionUnitCode
            }
          }
        ]
      }
    ) {
      id
      status
      effectiveDateTime
      subject {
        reference
      }
      meta {
        tag {
          code
          system
        }
      }
      component {
        code {
          coding {
            system
            code
            display
          }
        }
        valueString
        valueRange {
          low {
            value
          }
          high {
            value
          }
        }
        valueCodeableConcept {
          coding {
            system
            code
            display
          }
        }
      }
      extension {
        url
        valueString
      }
    }
  }
`;
export type CreateObservationFromExpressionVariantMutationFn =
  ApolloReactCommon.MutationFunction<
    CreateObservationFromExpressionVariantMutationResponse,
    CreateObservationFromExpressionVariantMutationVariables
  >;

/**
 * __useCreateObservationFromExpressionVariantMutation__
 *
 * To run a mutation, you first call `useCreateObservationFromExpressionVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObservationFromExpressionVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObservationFromExpressionVariantMutation, { data, loading, error }] = useCreateObservationFromExpressionVariantMutation({
 *   variables: {
 *      user: // value for 'user'
 *      datasetId: // value for 'datasetId'
 *      subjectRef: // value for 'subjectRef'
 *      variantId: // value for 'variantId'
 *      geneId: // value for 'geneId'
 *      expressionValue: // value for 'expressionValue'
 *      expressionUnitSystem: // value for 'expressionUnitSystem'
 *      expressionUnitCode: // value for 'expressionUnitCode'
 *      loincSequenceClass: // value for 'loincSequenceClass'
 *      sequenceType: // value for 'sequenceType'
 *      sequenceId: // value for 'sequenceId'
 *      testId: // value for 'testId'
 *      effectiveDateTime: // value for 'effectiveDateTime'
 *   },
 * });
 */
export function useCreateObservationFromExpressionVariantMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateObservationFromExpressionVariantMutationResponse,
    CreateObservationFromExpressionVariantMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    CreateObservationFromExpressionVariantMutationResponse,
    CreateObservationFromExpressionVariantMutationVariables
  >(CreateObservationFromExpressionVariantDocument, baseOptions);
}
export type CreateObservationFromExpressionVariantMutationHookResult =
  ReturnType<typeof useCreateObservationFromExpressionVariantMutation>;
export type CreateObservationFromExpressionVariantMutationResult =
  ApolloReactCommon.MutationResult<CreateObservationFromExpressionVariantMutationResponse>;
export type CreateObservationFromExpressionVariantMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateObservationFromExpressionVariantMutationResponse,
    CreateObservationFromExpressionVariantMutationVariables
  >;
export type CreateObservationFromShortVariantMutationVariables = Types.Exact<{
  user: Types.Scalars['String'];
  effectiveDateTime: Types.Scalars['String'];
  datasetId: Types.Scalars['String'];
  subjectRef: Types.Scalars['String'];
  variantId: Types.Scalars['String'];
  sequenceId: Types.Scalars['String'];
  testId: Types.Scalars['String'];
  ncChange: Types.Scalars['String'];
  aaChange: Types.Scalars['String'];
  gene: Types.Scalars['String'];
  refSeqId: Types.Scalars['String'];
  loincSequenceClass: Types.Scalars['String'];
  sequenceType: Types.Scalars['String'];
  position: Types.QuantityIn;
  refAllele: Types.Scalars['String'];
  altAllele: Types.Scalars['String'];
  setType: Types.Scalars['String'];
  alleleFrequency: Types.Scalars['Float'];
}>;

export type CreateObservationFromShortVariantMutationResponse = {
  __typename: 'Mutation';
  createObservation: {
    __typename: 'Observation';
    id?: Types.Maybe<string>;
    effectiveDateTime?: Types.Maybe<string>;
    subject?: Types.Maybe<{
      __typename: 'Reference';
      reference?: Types.Maybe<string>;
    }>;
    meta?: Types.Maybe<{
      __typename: 'Meta';
      tag?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          code?: Types.Maybe<string>;
          system?: Types.Maybe<string>;
        }>
      >;
    }>;
    component?: Types.Maybe<
      Array<{
        __typename: 'ObservationComponent';
        valueString?: Types.Maybe<string>;
        code?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              system?: Types.Maybe<string>;
              code?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
        valueCodeableConcept?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              system?: Types.Maybe<string>;
              code?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
      }>
    >;
    extension?: Types.Maybe<
      Array<{
        __typename: 'Extension';
        url?: Types.Maybe<string>;
        valueString?: Types.Maybe<string>;
      }>
    >;
  };
};

export type CreateObservationFromStructuralVariantMutationVariables =
  Types.Exact<{
    user: Types.Scalars['String'];
    datasetId: Types.Scalars['String'];
    subjectRef: Types.Scalars['String'];
    variantId: Types.Scalars['String'];
    testId: Types.Scalars['String'];
    effectCoding: Array<Types.Maybe<Types.CodingIn>>;
    geneIdCoding: Array<Types.Maybe<Types.CodingIn>>;
    position1: Types.RangeIn;
    position2: Types.RangeIn;
    loincSequenceClass: Types.Scalars['String'];
    sequenceType: Types.Scalars['String'];
    sequenceId: Types.Scalars['String'];
    effectiveDateTime: Types.Scalars['String'];
  }>;

export type CreateObservationFromStructuralVariantMutationResponse = {
  __typename: 'Mutation';
  createObservation: {
    __typename: 'Observation';
    id?: Types.Maybe<string>;
    status?: Types.Maybe<Types.ObservationStatus>;
    effectiveDateTime?: Types.Maybe<string>;
    subject?: Types.Maybe<{
      __typename: 'Reference';
      reference?: Types.Maybe<string>;
    }>;
    meta?: Types.Maybe<{
      __typename: 'Meta';
      tag?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          code?: Types.Maybe<string>;
          system?: Types.Maybe<string>;
        }>
      >;
    }>;
    component?: Types.Maybe<
      Array<{
        __typename: 'ObservationComponent';
        valueString?: Types.Maybe<string>;
        code?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              system?: Types.Maybe<string>;
              code?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
        valueRange?: Types.Maybe<{
          __typename: 'Range';
          low?: Types.Maybe<{
            __typename: 'Quantity';
            value?: Types.Maybe<number>;
          }>;
          high?: Types.Maybe<{
            __typename: 'Quantity';
            value?: Types.Maybe<number>;
          }>;
        }>;
        valueCodeableConcept?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              system?: Types.Maybe<string>;
              code?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
      }>
    >;
    extension?: Types.Maybe<
      Array<{
        __typename: 'Extension';
        url?: Types.Maybe<string>;
        valueString?: Types.Maybe<string>;
      }>
    >;
  };
};

export type CreateObservationFromCopyNumberVariantMutationVariables =
  Types.Exact<{
    user: Types.Scalars['String'];
    datasetId: Types.Scalars['String'];
    subjectRef: Types.Scalars['String'];
    variantId: Types.Scalars['String'];
    geneId: Types.Scalars['String'];
    position: Types.RangeIn;
    copyNumberValue: Types.Scalars['Float'];
    typeCoding: Array<Types.Maybe<Types.CodingIn>>;
    loincSequenceClass: Types.Scalars['String'];
    sequenceType: Types.Scalars['String'];
    sequenceId: Types.Scalars['String'];
    testId: Types.Scalars['String'];
    effectiveDateTime: Types.Scalars['String'];
  }>;

export type CreateObservationFromCopyNumberVariantMutationResponse = {
  __typename: 'Mutation';
  createObservation: {
    __typename: 'Observation';
    id?: Types.Maybe<string>;
    status?: Types.Maybe<Types.ObservationStatus>;
    effectiveDateTime?: Types.Maybe<string>;
    subject?: Types.Maybe<{
      __typename: 'Reference';
      reference?: Types.Maybe<string>;
    }>;
    meta?: Types.Maybe<{
      __typename: 'Meta';
      tag?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          code?: Types.Maybe<string>;
          system?: Types.Maybe<string>;
        }>
      >;
    }>;
    component?: Types.Maybe<
      Array<{
        __typename: 'ObservationComponent';
        valueString?: Types.Maybe<string>;
        code?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              system?: Types.Maybe<string>;
              code?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
        valueRange?: Types.Maybe<{
          __typename: 'Range';
          low?: Types.Maybe<{
            __typename: 'Quantity';
            value?: Types.Maybe<number>;
          }>;
          high?: Types.Maybe<{
            __typename: 'Quantity';
            value?: Types.Maybe<number>;
          }>;
        }>;
        valueCodeableConcept?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              system?: Types.Maybe<string>;
              code?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
      }>
    >;
    extension?: Types.Maybe<
      Array<{
        __typename: 'Extension';
        url?: Types.Maybe<string>;
        valueString?: Types.Maybe<string>;
      }>
    >;
  };
};

export type CreateObservationFromExpressionVariantMutationVariables =
  Types.Exact<{
    user: Types.Scalars['String'];
    datasetId: Types.Scalars['String'];
    subjectRef: Types.Scalars['String'];
    variantId: Types.Scalars['String'];
    geneId: Types.Scalars['String'];
    expressionValue: Types.Scalars['Float'];
    expressionUnitSystem: Types.Scalars['String'];
    expressionUnitCode: Types.Scalars['String'];
    loincSequenceClass: Types.Scalars['String'];
    sequenceType: Types.Scalars['String'];
    sequenceId: Types.Scalars['String'];
    testId: Types.Scalars['String'];
    effectiveDateTime: Types.Scalars['String'];
  }>;

export type CreateObservationFromExpressionVariantMutationResponse = {
  __typename: 'Mutation';
  createObservation: {
    __typename: 'Observation';
    id?: Types.Maybe<string>;
    status?: Types.Maybe<Types.ObservationStatus>;
    effectiveDateTime?: Types.Maybe<string>;
    subject?: Types.Maybe<{
      __typename: 'Reference';
      reference?: Types.Maybe<string>;
    }>;
    meta?: Types.Maybe<{
      __typename: 'Meta';
      tag?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          code?: Types.Maybe<string>;
          system?: Types.Maybe<string>;
        }>
      >;
    }>;
    component?: Types.Maybe<
      Array<{
        __typename: 'ObservationComponent';
        valueString?: Types.Maybe<string>;
        code?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              system?: Types.Maybe<string>;
              code?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
        valueRange?: Types.Maybe<{
          __typename: 'Range';
          low?: Types.Maybe<{
            __typename: 'Quantity';
            value?: Types.Maybe<number>;
          }>;
          high?: Types.Maybe<{
            __typename: 'Quantity';
            value?: Types.Maybe<number>;
          }>;
        }>;
        valueCodeableConcept?: Types.Maybe<{
          __typename: 'CodeableConcept';
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              system?: Types.Maybe<string>;
              code?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        }>;
      }>
    >;
    extension?: Types.Maybe<
      Array<{
        __typename: 'Extension';
        url?: Types.Maybe<string>;
        valueString?: Types.Maybe<string>;
      }>
    >;
  };
};
